import dynamic from 'next/dynamic';
import { SearchFormProps } from './SearchForm.types';

export const SearchFormDynamic = dynamic<{ model: SearchFormProps }>(
  () => import('./SearchForm').then(mod => mod.SearchForm),
  { ssr: false }
);

export { SearchForm } from './SearchForm';
